<template>
	<div class="relative inline-block mr-[-12px]" @click.stop>
		<Z-icon-button @click="toggleDropdown" :icon="icons.copy" :disabled="disabled" :loading="loading">
			<div class="flex">
				<span>{{ $t("Kopírovať výsledok") }}</span>
				<ion-icon :class="{ 'rotate-icon': showDropdown }" :icon="icons.arrowDown" class="arrow" />
			</div>
		</Z-icon-button>

		<div v-if="showDropdown" class="dropdown" v-click-outside="closeDropdown">
			<div class="dropdown__item" v-for="(option, index) in options" :key="`dropdown-option-${index}`"
				@click="option.handler(); closeDropdown()">
				<img v-if="option.image" :src="option.image" />
				<div v-else class="skelet w-[130px] h-[80px]" />

				<div>
					<p>{{ option.title }}</p>
					<span>{{ option.description }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { copy, arrowDown } from '@/plugins/@medirex/icons'
import { Clipboard } from '@capacitor/clipboard'

export default {
	props: {
		options: {
			type: [Array],
			default: () => []
		},

		disabled: {
			type: [Boolean],
			default: false
		},

		loading: {
			type: [Boolean],
			default: false
		}
	},

	setup() {
		return {
			icons: {
				copy,
				arrowDown
			}
		}
	},

	data () {
		return {
			showDropdown: false,
		}
	},

	methods: {
		toggleDropdown() {
			this.showDropdown = !this.showDropdown
		},

		closeDropdown() {
			this.showDropdown = false
		}
	}
}
</script>

<style lang="sass" scoped>
@import '@/plugins/app/theme/_mixins/responsive.mixin'
.arrow
	margin-left: 8px
	margin-right: 0

.rotate-icon
	transform: rotate(180deg) translateY(2px)
	margin-right: 0

ion-icon
	@apply inline-block text-[--ion-color-primary] h-[7px] mt-[5px]

.dropdown
	position: absolute
	background-color: #FFF
	right: 12px
	min-width: 351px
	box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.20)
	z-index: 100
	cursor: pointer

	+sm
		@apply max-w-[300px] min-w-[250px]

	@media only screen and (max-width: 870px)
		@apply left-0

	&__item
		@apply min-h-[80px] flex justify-start items-center gap-[20px]
		padding: 20px
		text-decoration: none
		border-top: 1px #E1E6EB solid

		+md
			@apply py-[8px] px-[11px]

		&:hover
			background-color: #f1f1f1

		&:first-child
			border-top: none

		img
			@apply h-[40px] w-[65px] object-cover

		p
			margin: 0
			font-size: 14px
			color: var(--ion-color-primary)
			font-family: Inter, serif
			font-style: normal

			+sm
				@apply text-xs

		span
			color: #6E7D8D
			font-family: Inter, serif
			font-size: 14px
			font-style: normal
			font-weight: 400

			+sm
				@apply text-xs
</style>